import { render, staticRenderFns } from "./FlushMessage.vue?vue&type=template&id=0838af4a&scoped=true&"
import script from "./FlushMessage.vue?vue&type=script&lang=ts&"
export * from "./FlushMessage.vue?vue&type=script&lang=ts&"
import style0 from "./FlushMessage.vue?vue&type=style&index=0&id=0838af4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0838af4a",
  null
  
)

export default component.exports